import React from "react";
import styled from "styled-components";
import { stringToSlug } from "../functions/util";
import Box from "./box";
import VideoBox from "./video-box";
import { Button } from "./globals/button";
import ImageBox from "./image-box";
import { Wrapper } from "./style/global-styles";
import Arrow from "../components/svg/arrow";

function SectionButton({ data, ...rest }) {
  const ButtonWrapper = styled.div`
    a {
      display: inline-block;
      color: var(--post-accent-color) !important;

      &:hover,
      &:active {
        background: var(--post-accent-color) !important;
      }
    }
  `;
  return (
    <>
      {data.url && (
        <ButtonWrapper className="pB" {...rest}>
          <Button
            href={data.url}
            blank={data.target === "_blank"}
            icon={data.target === "_blank" ? <Arrow /> : null}
          >
            {data.url.replace("https://", "")}
          </Button>
        </ButtonWrapper>
      )}
    </>
  );
}

function SectionCaption({ data, dataLayout, ...rest }) {
  return (
    <>
      {data && (
        <p className="caption" {...rest}>
          {data}
        </p>
      )}
    </>
  );
}

export function PostDoubleImage({ data: { primary } }) {
  return (
    <>
      {primary.double_image_title.text && (
        <SectionHeader>
          <h4 className="sequel">{primary.double_image_title.text}</h4>
        </SectionHeader>
      )}
      <DoublePhotoWrapper
        data-layout={stringToSlug(primary.double_image_layout)}
      >
        {primary.video_1_override.url ? (
          <VideoBox
            className="image image_1"
            video={primary.video_1_override}
          />
        ) : (
          <ImageBox className="image image_1" fluid={primary.image_1.fluid} />
        )}

        {primary.video_2_override.url ? (
          <VideoBox
            className="image image_2"
            video={primary.video_2_override}
          />
        ) : (
          <ImageBox className="image image_2" fluid={primary.image_2.fluid} />
        )}
        <SectionCaption data={primary.caption} data-show="laptop" />
        <SectionButton data={primary.button.raw} data-show="laptop" />
      </DoublePhotoWrapper>
      <Wrapper>
        <div data-show="mobile">
          <SectionButton
            data={primary.button.raw}
            style={{ marginBottom: "2rem" }}
            data-show="mobile"
          />
          <SectionCaption data={primary.caption} data-show="mobile" />
        </div>
      </Wrapper>
    </>
  );
}

const SectionHeader = styled(Wrapper)`
  margin-top: 6vw;
  margin-bottom: 2vw;

  h4 {
    color: var(--post-accent-color);
  }
`;

const DoublePhotoWrapper = styled(Box)`
  display: flex;
  height: fit-content;
  position: relative;
  margin: 8vw;

  .image {
    width: 50%;
  }

  .caption {
    position: absolute;
    width: 40%;
    bottom: 0;

    h6 {
      width: 30em;
      line-height: 1.7;
      margin-bottom: 0;
    }
  }

  .caption,
  .button {
    position: absolute;
    bottom: 0;
  }

  &[data-layout="sm-left-large-right"] {
    .image_1 {
      width: 40%;
      height: 40%;
    }
    .image_2 {
      width: 60%;
      transform: translateX(8vw) !important;
    }

    .caption,
    .button {
      left: 0;
    }
  }

  &[data-layout="large-left-small-right"] {
    .image_1 {
      width: 60%;
      transform: translateX(-8vw) !important;
    }
    .image_2 {
      width: 40%;
      height: 40%;
    }

    .caption,
    .button {
      right: 0;
    }
  }
`;
